import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize, tap } from 'rxjs';

import { ObservabilityService } from './observability.service';

export const observabilityInterceptor: HttpInterceptorFn = (request, next) => {
  const observability = inject(ObservabilityService);
  const startedAt = performance.now();
  let ok = true;

  return next(request).pipe(
    tap({
      error: (error: unknown) => {
        ok = false;
        observability.error(`http ${request.method} ${request.url}`, error);
      },
    }),
    finalize(() =>
      observability.timing({
        name: `${request.method} ${request.url}`,
        durationMs: Math.round(performance.now() - startedAt),
        ok,
      }),
    ),
  );
};
